import { EGetRunningJackpotsStatus } from '@gaming1/g1-requests-gaming';

export const getPlatformJackpotsErrorMessages = {
  [EGetRunningJackpotsStatus.InternalError]: 'core:error.internalServer', // 0
};
